import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib";
import { CreateContractRequestDTO, RequestContractsResponse } from "@/types";

async function createContract(
  request: CreateContractRequestDTO
): Promise<RequestContractsResponse> {
  const response = await httpRequest.post<RequestContractsResponse>(
    "/contracts",
    request
  );
  return response.data;
}

export function useCreateContractMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createContract,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["contracts"] });
    },
  });
}
